const URLASSOLUTO = window.URLASSOLUTO;
const URLASSOLUTOISTITUZIONALE = window.URLASSOLUTOISTITUZIONALE;
const CURRENTROUTENAME = window.CURRENTROUTENAME;
const VIEWNAME = window.VIEWNAME;
const TEMPLATEID = window.TEMPLATEID;
delete window.URLASSOLUTO;
delete window.URLASSOLUTOISTITUZIONALE;
delete window.CURRENTROUTENAME;
delete window.VIEWNAME;
delete window.METATEMPLATEALTERNATE;
delete window.TEMPLATEID;

export {
    URLASSOLUTO,
    URLASSOLUTOISTITUZIONALE,
    CURRENTROUTENAME,
    VIEWNAME,
    TEMPLATEID,
};
